import React from 'react'
import { useUserProfile } from '../../Hook/App'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
import { fileToDataUri } from '../../Utils';
function Index() {
    const { user, load, edit, setForm, setPreview, preview } = useUserProfile();

    return (
        <Layout>
            <HeaderMain lable="ویرایش حساب کربری" />
            <div className="edit-main">
                <div className="profile-img">
                    <div className='img-cont'>
                        <input name='profile' onChange={(prop) => {
                            fileToDataUri(prop.target.files[0]).then(dataUri => {
                                setPreview(dataUri);
                                setForm(prop.target.name, prop.target.files);
                            })
                        }} type="file" style={{ opacity: 0, width: "100%", height: "100%", position: "absolute" }} />
                        <img src={preview || user.meta_data && user.meta_data.profile} />
                    </div>
                </div>
                <p className="lable">نام</p>
                <input onChange={({ target }) => setForm('name', target.value)} type="text" className="input" placeholder={user.name} />
                <p className="lable">شماره تماس</p>
                <input onChange={({ target }) => setForm("mobile", target.value)} type="number" className="input" placeholder={user.mobile} />
                <p className="lable">ایمیل</p>
                <input onChange={({ target }) => setForm("email", target.value)} type="email" className="input" placeholder={user.email} />

                <button className="btn" disabled={load} onClick={edit}>{load ? <span className="spinner-border spinner-border-sm"></span> : "اعمال تغییرات"}</button>
            </div>
        </Layout>
    )
}

export default Index